export default "__VITE_ASSET__C0H6T3I$__"